import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { deofuscate } from '@/utils/obfuscation';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { Variant } from '@/interfaces/transaction-result';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './delete-result.component.html',
  styleUrls: ['./delete-result.component.css'],
})
export class DeleteResultComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
  ) { }

  email: string = '';
  variant: Variant = 'success';
  message: string = '';
  subtitle: string = 'La solicitud de licencia ha sido eliminada correctamente';

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    // { text: 'Aprobar Solicitudes', path: '/license/approve' },
  ]

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const paramsWithId = deofuscate(ofuscatedData);

      this.email = paramsWithId.email || '';
      this.variant = paramsWithId.variant || 'success';

      if (this.variant === 'success') {
        this.message = `Una copia de la eliminacion fue enviada al correo electrónico ${this.email}`;
      }
      if (this.variant === 'failure') {
        this.subtitle = 'Hubo un problema y no hemos podido eliminar la solicitud. Por favor intenta de nuevo.';
      }
    });
  }

}
